export const defaultInfos = [];
export const defaultCautions = [
  {
    contents:
      '응모하기는 응모를 한 후 취소가 불가능하며, 응모에 사용한 얼스 크레딧 역시 환불이 불가능해요.',
  },
  {
    contents:
      '회원당 응모 가능 횟수는 1회로 제한되어 있어 중복 응모는 불가능해요.',
  },
  {
    contents:
      '에코야얼스에서 이벤트 종료 후 7일 이내에 응모 당첨자 안내를 공지사항 공지, 커뮤니티를 통해 진행하고 있어요.',
  },
  {
    contents:
      '응모하기에 참여하는 회원은 당첨자 선정 및 상품 배송을 위해 최소한의 개인정보 수집 및 활용에 동의하는 것으로 간주하고 있으며, 이에 동의하지 않는 경우는 응모 참여가 불가능해요.',
  },
  {
    contents:
      '응모 과정이나 당첨자 선정에서 기술적 문제가 발생할 경우, 에코야 얼스 앱 > 전체 > 1:1문의 페이지 혹은 에코야 얼스 카카오톡 채널에 문의해 주세요.',
  },
  {
    contents:
      '응모 컨텐츠 별로 당첨자 선정방식은 다를 수 있어요.(선착순, 랜덤 추첨 등)',
  },
  {
    contents:
      '선착순이 아닌 응모는 전체 참여자 중 랜덤 추첨을 통한 당첨자를 선정해요.',
  },
  {
    contents:
      '에코야 얼스 응모하기 당첨 내역은 타인에게 양도가 불가하며, 경품에 상응하는 현금으로 대체 지급은 불가능해요.',
  },
];
